import { render, staticRenderFns } from "./bingliSee.vue?vue&type=template&id=8bb2a3e4&scoped=true&"
import script from "./bingliSee.vue?vue&type=script&lang=js&"
export * from "./bingliSee.vue?vue&type=script&lang=js&"
import style0 from "./bingliSee.vue?vue&type=style&index=0&id=8bb2a3e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb2a3e4",
  null
  
)

export default component.exports